import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=3ff1c6c2&scoped=true"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=3ff1c6c2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff1c6c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff1c6c2')) {
      api.createRecord('3ff1c6c2', component.options)
    } else {
      api.reload('3ff1c6c2', component.options)
    }
    module.hot.accept("./Sidebar.vue?vue&type=template&id=3ff1c6c2&scoped=true", function () {
      api.rerender('3ff1c6c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/vertical/Sidebar.vue"
export default component.exports